import React from 'react';
import shackBlack from 'assets/img/shaka-black.png';
import shackFilled from 'assets/img/shaka-filled.png';

export default ({ checked, size }) => {
  return (
    <>
      <img src={checked === true ? shackFilled : shackBlack} alt="" style={{ width: size }} />
    </>
  );
};
